// jmix-7-3: pure, React-free helpers for the /set-password landing page (unit-testable without a DOM).
// The reset token is admin-issued and arrives in the URL FRAGMENT (`/set-password#<token>`) — never a
// query string — so it stays out of the Referer header and server access logs. The page reads it once,
// then strips the fragment from the address bar (history.replaceState) so it can't leak to onward
// navigation or a copied URL. The token lives in component state only — never web storage.

const SET_PASSWORD_PATH = "/set-password";

/** True when the current path is the set-password landing route (trailing slash tolerated). */
export function isSetPasswordPath(pathname: string | null | undefined): boolean {
  if (!pathname) {
    return false;
  }
  return pathname.replace(/\/+$/, "") === SET_PASSWORD_PATH;
}

/**
 * Extract the reset token from a URL fragment (`location.hash`). Accepts the value with or without the
 * leading `#`; returns the trimmed token, or `""` when there is none. Takes the hash as an argument
 * (not `location`) so it is testable in isolation.
 */
export function readResetTokenFromHash(hash: string | null | undefined): string {
  if (!hash) {
    return "";
  }
  const raw = hash.startsWith("#") ? hash.slice(1) : hash;
  return raw.trim();
}
